import APIS from 'src/constants/ApiConfig';
import {
  ORDER_STATUS,
  PAYMENT_ALIPY,
  PAYMENT_PAYPAL,
  PAYMENT_POSTPAID,
  PAYMENT_WECHAT,
  ORDER_PAYMENT,
  EPayStatus,
  payStatusToOrderStatus,
  PAYMENT_ALIPAY_ORG,
  PAYMENT_WECHAT_ORG,
  PAYMENT_ACCOUNT_BALANCE,
  CODEPAY_VSP_ORG,
  PAYMENT_UNION_ORG,
  EXTERNAL_ONLINE,
  EXTERNAL_OFFLINE,
  PAYMENT_GIFT,
  OFF_LINE,
  WECHAT_MP_PAY_ORG,
  H5_CASHIER_VSP_ORG
} from 'src/constants/Order';
import { ICommonResult, IPageResult } from 'src/entity/BaseResult';
import { ICurrencyType, IOrderInfo, IOrderPayment, IOrderRemark, IOrderStatus, IOrderListInfo, IOrderRefund } from 'src/entity/OrderEntity';
import { IOrderSearch } from 'src/entity/SearchEntity';
import HttpService from 'src/services/HttpService';
import I18N from 'src/services/I18NService';
import { ILogisticsInfo } from 'src/entity/logistics';
import { ConfigOrderType } from '../constants/Order';
import { ITranslate } from 'src/entity/BasicEntity';
import { message } from 'antd';

export const OrderPayment: IOrderPayment[] = [
  { key: 'common_alipy', value: PAYMENT_ALIPY, is_set: true, is_show: true, desc: '支付宝' },
  { key: 'common_wechat', value: PAYMENT_WECHAT, is_set: false, is_show: true, desc: '微信' },
  { key: 'common_paypal', value: PAYMENT_PAYPAL, is_set: true, is_show: true, desc: 'Paypal' },
  { key: 'common_account', value: PAYMENT_POSTPAID, is_set: false, is_show: true, desc: '记账' },
  { key: 'common_gift', value: PAYMENT_GIFT, is_set: false, is_show: true, desc: '赠品' },
  { key: 'common_alipy', value: PAYMENT_ALIPAY_ORG, is_set: false, is_show: false, desc: '支付宝' }, // 通联(支付宝)
  { key: 'common_wechat', value: PAYMENT_WECHAT_ORG, is_set: false, is_show: false, desc: '微信' }, // 通联(微信)
  { key: 'common_balancePay', value: PAYMENT_ACCOUNT_BALANCE, is_set: false, is_show: true, desc: '余额支付' }, // 通联(微信)
  { key: 'common_offlinePay', value: OFF_LINE, is_set: false, is_show: true, desc: '线下付款' }, // 线下付款
  { key: 'common_barcodePay', value: CODEPAY_VSP_ORG, is_set: false, is_show: true, desc: '反扫' }, // 反扫
  { key: 'common_unionPay', value: PAYMENT_UNION_ORG, is_set: false, is_show: true, desc: '银联' }, // 通联(银联)
  { key: 'common_unionPay', value: PAYMENT_UNION_ORG, is_set: false, is_show: true, desc: '银联' }, // 通联(银联)
  { key: 'common_externalOnline', value: EXTERNAL_ONLINE, is_set: false, is_show: true, desc: '外部（线上）' }, // 外部（线上）
  { key: 'common_externalOffline', value: EXTERNAL_OFFLINE, is_set: false, is_show: true, desc: '外部（线下）' }, // 外部（线下）
  { key: 'common_wechat', value: WECHAT_MP_PAY_ORG, is_set: false, is_show: true, desc: '微信' }, // 患者小程序+
  { key: 'common_h5Cashier', value: H5_CASHIER_VSP_ORG, is_set: false, is_show: true, desc: '扫码支付' }, // 患者小程序
];

export const OrderStatus: IOrderStatus[] = [
  { key: 'common_status_pending', value: ORDER_STATUS.STATUS_PAID, desc: '待处理' },
  { key: 'common_status_finish', value: ORDER_STATUS.STATUS_FINISHED, desc: '已完成' },
];

// TODO: 建议改为从后端接口获取
export const CurrencyType: ICurrencyType[] = [
  { key: 'common_currency_rmb', value: 'CNY', desc: '人民币', isDomestic: true },
  { key: 'common_currency_usd', value: 'USD', desc: '美元', isDomestic: false },
  { key: 'common_currency_gbp', value: 'GBP', desc: '英镑', isDomestic: false },
  { key: 'common_currency_euro', value: 'EUR', desc: '欧元', isDomestic: false },
  { key: 'common_currency_jpy', value: 'JPY', desc: '日元', isDomestic: false },
  { key: 'common_currency_krw', value: 'KRW', desc: '韩元', isDomestic: false },
  { key: 'common_currency_hkd', value: 'HKD', desc: '港元', isDomestic: false },
  { key: 'common_currency_sgd', value: 'SGD', desc: '新加坡元', isDomestic: false },
  { key: 'common_currency_aud', value: 'AUD', desc: '澳元', isDomestic: false },
  { key: 'common_currency_chf', value: 'CHF', desc: '瑞士法郎', isDomestic: false },
  { key: 'common_currency_dkk', value: 'DKK', desc: '丹麦克朗', isDomestic: false },
  { key: 'common_currency_sek', value: 'SEK', desc: '瑞典克朗', isDomestic: false },
  { key: 'common_currency_nok', value: 'NOK', desc: '挪威克朗', isDomestic: false },
  { key: 'common_currency_isk', value: 'ISK', desc: '冰岛克朗', isDomestic: false },
];

/**
 * @description 发票状态枚举
 * @export
 * @enum {number}
 */
export enum EnumInvoiceStatus {
  未申请 = 1,
  未开具 = 2,
  已开具 = 3,
}

/**
 * 发票状态
 */
export const InvoiceStatusList: ITranslate[] = [
  {
    key: 'order_invoice_status_not_applied',
    value: EnumInvoiceStatus.未申请,
    name: '未申请',
  },
  {
    key: 'order_invoice_status_not_issued',
    value: EnumInvoiceStatus.未开具,
    name: '未开具',
  },
  {
    key: 'order_invoice_status_issued',
    value: EnumInvoiceStatus.已开具,
    name: '已开具',
  },
];

interface ILocation {
  readonly id: number;
  readonly full_name: string;
  readonly division_names: string;
}

class OrderService {
  private locationCache = new Map<number, ILocation>();
  /**
   * 查询药品/处方订单
   *
   * @memberof OrderService
   */
  getOrders = (query: IOrderSearch): Promise<IPageResult<IOrderListInfo[]>> => {
    if (!!query.created_time__gte) {
      const startDate = new Date(query.created_time__gte);
      query.created_time__gte = startDate.toISOString();
    }
    if (!!query.created_time__lt) {
      const endDate = new Date(query.created_time__lt);
      query.created_time__lt = endDate.toISOString();
    }
    return HttpService.get(APIS.domainUrl(APIS.drugStoreOrderList), query);
  };

  /**
   * @description: 导出订单 / 订单明细， 由后端直接导出
   */
  exportOrder2Excel = async (query: IOrderSearch, isDetail: boolean = false): Promise<boolean> => {
    if (!!query.created_time__gte) {
      const startDate = new Date(query.created_time__gte);
      query.created_time__gte = startDate.toISOString();
    }
    if (!!query.created_time__lt) {
      const endDate = new Date(query.created_time__lt);
      query.created_time__lt = endDate.toISOString();
    }
    let api = `${APIS.domainUrl(APIS.exportDrugOrderList)}`;
    if (isDetail) {
      api = `${APIS.domainUrl(APIS.exportDrugOrderDetailList)}`;
    }
    const success = await this.exportData(api, isDetail ? '订单明细导出' : '订单导出', query);
    return success;
  };

  /**
   * 根据id获取单个订单的明细
   *
   * @memberof OrderService
   */
  getOrderInfo = (id: string): Promise<IOrderInfo> => {
    return HttpService.get(`${APIS.domainUrl(APIS.drugStoreOrder)}${id}/`);
  };

  /**
   * 获取订单状态对应的描述
   *
   * @memberof OrderService
   */
  getStatusDesc = (value: ORDER_STATUS): string => {
    const obj = OrderStatus.find((s) => s.value === value);
    if (!!obj) {
      return I18N.get(obj.key);
    }
    return '';
  };

  getPayStatusDesc = (value: EPayStatus): string => {
    const status = payStatusToOrderStatus(value);
    let str = '';
    switch (status) {
      case ORDER_STATUS.STATUS_PAID:
        str = I18N.get('common_status_pending');
        break;
      case ORDER_STATUS.STATUS_FINISHED:
        str = I18N.get('common_status_finish');
        break;
      case ORDER_STATUS.STATUS_SENT:
        str = I18N.get('common_status_sent');
        break;
      case ORDER_STATUS.STATUS_SIGNED:
        str = I18N.get('common_status_signed');
        break;
      case ORDER_STATUS.STATUS_OTHER:
        str = I18N.get('common_status_canceled');
        break;
    }
    return str;
  };

  /**
   * 更新订单备注
   *
   * @param {string} id
   * @param {IOrderRemark} data
   * @returns
   * @memberof OrderService
   */
  updateOrderAgentRemarks(id: string, data: IOrderRemark) {
    return HttpService.patch(`${APIS.domainUrl(APIS.drugStoreOrder)}${id}/`, data);
  }

  /**
   * 取消订单-- 退款
   * @param no 订单号
   * @param amount 退款金额
   * @param reason 退款理由
   * @returns
   * @memberof OrderService
   *
   */
  cancelOrder(no: string, amount: number, reason: string) {
    return HttpService.post(APIS.domainUrl(APIS.drugOrderOp), {
      operation: 'APPLY_FOR_REFUND',
      refund_amount: amount,
      trade_no: no,
      why: reason,
    });
  }

  /**
   * 自提取消
   * @param no 订单号
   * @returns
   */
  selfCancelOrder(no: string) {
    return HttpService.post(APIS.domainUrl(APIS.drugOrderOp), {
      operation: 'CANCEL',
      trade_no: no,
      why: '',
    });
  }

  /**
   * 更新订单首次打印时间
   *
   * @param {string} id
   * @returns
   * @memberof OrderService
   */
  updatePrintDate(id: string) {
    const data = {
      first_print_prescription_time: new Date().toISOString(),
    };
    try {
      HttpService.patch(`${APIS.domainUrl(APIS.drugStoreOrder)}${id}/`, data);
    } catch (error) {
      console.error(error);
      message.error(error.message);
    }
  }

  /**
   * 更新订单首次打印时间
   *
   * @param {string} id
   * @returns
   * @memberof OrderService
   */
  updatePrintLogisticsDate(id: string) {
    const data = {
      first_print_logistics_time: new Date().toISOString(),
    };
    try {
      HttpService.patch(`${APIS.domainUrl(APIS.drugStoreOrder)}${id}/`, data);
    } catch (error) {
      console.error(error);
      message.error(error.message);
    }
  }

  /** 完成订单 */
  finishOrder(no: string) {
    return HttpService.post(APIS.domainUrl(APIS.drugOrderOp), {
      operation: 'PROCESS_DELIVER',
      trade_no: no,
      why: '',
    });
  }

  /** 确认收款 */
  confirmPaymentOrder(no: string) {
    return HttpService.post(APIS.domainUrl(APIS.drugOrderOp), {
      operation: 'HAS_PAID',
      why: 'Postpaid order auto trigger.',
      trade_no: no,
    });
  }

  /**
   * 获取订单发票的物流信息
   * @param id 订单主键
   */
  getInvoiceInfo(id: string) {
    return HttpService.get(`${APIS.domainUrl(APIS.drugStoreInvoice)}`, { drug_order_pk: id });
  }

  /**
   * 变更订单发票的物流信息
   * @param id 订单主键
   * @param data 物流信息
   */
  updateInvoiceLogistics(id: string, data: ILogisticsInfo) {
    return HttpService.patch(`${APIS.domainUrl(APIS.drugStoreInvoice)}${id}/`, data);
  }

  /**
   * 通过value获取支付方式描述
   *
   * @param {ORDER_PAYMENT} value
   * @returns {string}
   * @memberof OrderService
   */
  getPaymentDescByValue(value: ORDER_PAYMENT): string {
    const obj = OrderPayment.find((t) => t.value === value);
    if (!!obj && !!obj.key) {
      return I18N.get(obj.key);
    }
    return '';
  }

  getOrderType = (value: number): string => {
    const obj = ConfigOrderType.find((t) => t.value === value);
    if (!!obj) {
      return I18N.get(obj.key);
    }
    return '';
  };

  /** 获取省市区地址 */
  async getLocationArea(area: number) {
    if (this.locationCache.has(area)) {
      return this.locationCache.get(area);
    }

    const res: IPageResult<ReadonlyArray<ILocation>> = await HttpService.get(`${APIS.domainUrl(APIS.location)}`, { area });

    if (res && res.results && res.results.length > 0) {
      this.locationCache.set(area, res.results[0]);
      return res.results[0];
    }

    return undefined;
  }

  instantLocationArea(area: number) {
    if (this.locationCache.has(area)) {
      return this.locationCache.get(area);
    }
    return undefined;
  }

  getOrderInvoiceStatusDesc(value: EnumInvoiceStatus): string {
    const obj = InvoiceStatusList.find((t) => t.value === value);
    return !!obj ? I18N.get(obj.key, false) : '';
  }

  /**
   * @description 开具和取消开具的发票操作
   * @date 2020-01-21
   * @param invoiceUUID
   * @param operation
   * @returns
   */
  async changeInvoiceStatus(invoiceUUID: string, operation: 'ISSUE' | 'CANCEL_ISSUE'): Promise<boolean> {
    try {
      if (!!invoiceUUID) {
        const url = `${APIS.domainUrl(APIS.agent.invoiceOperation)}`;
        const res: { operation_status: string } = await HttpService.post(url, {
          operation,
          invoice_uuid: invoiceUUID,
        });
        if (!!res && res.operation_status.toLocaleLowerCase() === 'ok') {
          return true;
        }
      }
    } catch (error) {
      console.error(error);
    }
    return false;
  }

  /**
   * 导出处方订单Excel
   *
   * @memberof OrderService
   */
  exportOrderExcel = async (uuid: string): Promise<boolean> => {
    // let isSucceeded = false;
    const api = `${APIS.domainUrl(APIS.drugStoreOrderList)}${uuid}/export-drug/`;
    const isSucceeded = await this.exportData(api, '药品明细导出');
    // try {
    //   const res: any = await HttpService.post(api, null, {'content-type': 'application/octet-stream', responseType: 'arraybuffer'});
    //   if (res) {
    //     const blob = new Blob([res], { type: 'application/octet-stream' });
    //     const downLoadUrl = window.URL.createObjectURL(blob);
    //     if (!!downLoadUrl) {
    //       const downLoadLink = document.createElement('a');
    //       downLoadLink.download = '药品明细导出.xlsx';
    //       downLoadLink.href = downLoadUrl;
    //       downLoadLink.style.display = 'none';
    //       // 兼容：某些浏览器不支持HTML5的download属性
    //       if (typeof downLoadLink.download === 'undefined') {
    //         downLoadLink.setAttribute('target', '_blank');
    //       }
    //       // 触发点击
    //       document.body.appendChild(downLoadLink);
    //       downLoadLink.click();
    //       // 然后移除
    //       document.body.removeChild(downLoadLink);
    //       // 释放blob URL地址
    //       window.URL.revokeObjectURL(downLoadUrl);
    //       isSucceeded = true;
    //     }
    //   }
    // } catch (error) {
    //   console.error('exportOrderExcel failed: ', error);
    // }
    return isSucceeded;
  };

  exportData = async (url: string, fileName: string, query?: IOrderSearch): Promise<boolean> => {
    let flag = false;
    try {
      let res: any;
      if (query) {
        res = await HttpService.get(url, query, { 'content-type': 'application/octet-stream', responseType: 'arraybuffer' });
      } else {
        res = await HttpService.post(url, null, { 'content-type': 'application/octet-stream', responseType: 'arraybuffer' });
      }
      if (res) {
        const blob = new Blob([res], { type: 'application/octet-stream' });
        const downLoadUrl = window.URL.createObjectURL(blob);
        if (!!downLoadUrl) {
          const downLoadLink = document.createElement('a');
          downLoadLink.download = `${fileName}.xlsx`;
          downLoadLink.href = downLoadUrl;
          downLoadLink.style.display = 'none';
          // 兼容：某些浏览器不支持HTML5的download属性
          if (typeof downLoadLink.download === 'undefined') {
            downLoadLink.setAttribute('target', '_blank');
          }
          // 触发点击
          document.body.appendChild(downLoadLink);
          downLoadLink.click();
          // 然后移除
          document.body.removeChild(downLoadLink);
          // 释放blob URL地址
          window.URL.revokeObjectURL(downLoadUrl);
          flag = true;
        }
      }
    } catch (error) {
      console.error('exportOrderExcel failed: ', error);
      flag = false;
    }
    return flag;
  };

  /** 获取业务订单的退款详情 */
  fetchOrderRefundInfoList = async (orderNo: string): Promise<IOrderRefund[]> => {
    const api = APIS.domainUrl(APIS.refundOrder);
    try {
      const res: ICommonResult<IOrderRefund[]> = await HttpService.get(`${api}`, { business_out_trade_no: orderNo });
      if (!!res) {
        return res.data || [];
      }
    } catch (error) {
      console.error(error);
    }
    return [];
  };
}

export default new OrderService();



// WEBPACK FOOTER //
// ./src/services/OrderService.ts